import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {ApiService} from '../../../../_services/api.service';
import {FormHelperService} from '../../services/form-helper.service';

@Component({
  selector: 'app-additional-signer',
  templateUrl: './additional-signer.component.html',
  styleUrls: ['./additional-signer.component.scss']
})
export class AdditionalSignerComponent implements OnInit {

  accessLink: string | null;
  errorMessage: string | null;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              public formHelper: FormHelperService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      if (params.docId === undefined) {
        this.errorMessage = 'No document ID supplied.';
        return;
      }

      this.apiService.secondSignerAccessLink(params.docId).subscribe((accessLink: string) => {
        this.accessLink = accessLink;
        this.errorMessage = null;
      }, error => {
        this.accessLink = null;
        this.errorMessage = error;
      });
    });
  }

}
